import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href", "x", "y", "width", "height"]
const _hoisted_3 = ["x", "y", "width", "height"]
const _hoisted_4 = { class: "custom-hotspot-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["cx", "cy", "r"]
const _hoisted_9 = ["from", "to"]
const _hoisted_10 = ["cx", "cy", "r"]
const _hoisted_11 = ["href", "x", "y", "width", "height"]
const _hoisted_12 = ["href", "x", "y", "width", "height"]
const _hoisted_13 = ["id"]
const _hoisted_14 = ["x", "y", "width"]
const _hoisted_15 = { class: "ad-PointDropdown-Container" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("g", {
      onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleDropdown(true))),
      onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDropdown(false))),
      onMousedown: _cache[3] || (_cache[3] = (e) => _ctx.setDraggedPoint(_ctx.index))
    }, [
      (_ctx.item.iconFile && _ctx.customHotspots)
        ? (_openBlock(), _createElementBlock("g", _hoisted_1, [
            _createElementVNode("image", {
              href: _ctx.item.iconFile,
              x: _ctx.x - _ctx.hotspotImageWidth / 2 - 2.5,
              y: _ctx.y + 2.5 - _ctx.hotspotDiameter / 2,
              width: _ctx.hotspotImageWidth,
              height: _ctx.hotspotImageHeight,
              class: "ad-Point"
            }, null, 8, _hoisted_2),
            (_openBlock(), _createElementBlock("foreignObject", {
              x: _ctx.x - _ctx.hotspotImageWidth / 2 - 2.5,
              y: _ctx.y + 2.5 - _ctx.hotspotDiameter / 2,
              width: _ctx.hotspotImageWidth,
              height: _ctx.hotspotImageHeight
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", {
                  class: "hotspot-title",
                  innerHTML: _ctx.title
                }, null, 8, _hoisted_5),
                _createElementVNode("p", {
                  class: "hotspot-description",
                  innerHTML: _ctx.description
                }, null, 8, _hoisted_6),
                _createElementVNode("p", {
                  class: "hotspot-completion",
                  innerHTML: _ctx.progressCompleteText
                }, null, 8, _hoisted_7)
              ])
            ], 8, _hoisted_3))
          ]))
        : _createCommentVNode("", true),
      (_ctx.checkActiveHotspot)
        ? (_openBlock(), _createElementBlock("circle", {
            key: 1,
            class: "innerCircle",
            cx: _ctx.x,
            cy: _ctx.y,
            r: _ctx.hotspotDiameter / 2,
            fill: "#FFFFFF",
            stroke: "#FFFFFF",
            "stroke-width": "5%"
          }, [
            _createElementVNode("animate", {
              attributeType: "SVG",
              attributeName: "r",
              begin: "0s",
              dur: "1.5s",
              repeatCount: "indefinite",
              from: _ctx.pulseStart,
              to: _ctx.pulseEnd
            }, null, 8, _hoisted_9),
            _cache[4] || (_cache[4] = _createElementVNode("animate", {
              attributeType: "CSS",
              attributeName: "stroke-width",
              begin: "0s",
              dur: "1.5s",
              repeatCount: "indefinite",
              from: "3%",
              to: "0%"
            }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("animate", {
              attributeType: "CSS",
              attributeName: "opacity",
              begin: "0s",
              dur: "1.5s",
              repeatCount: "indefinite",
              from: "1",
              to: "0"
            }, null, -1))
          ], 8, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("circle", {
        class: _normalizeClass(["ad-Point", { edit: _ctx.edit, 'ad-Point--has-icon': _ctx.item.iconFile }]),
        onDblclick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDoubleClick(_ctx.index))),
        cx: _ctx.x,
        cy: _ctx.y,
        r: _ctx.hotspotDiameter / 2
      }, null, 42, _hoisted_10),
      (_ctx.item.iconFile && !_ctx.customHotspots && !_ctx.completed)
        ? (_openBlock(), _createElementBlock("image", {
            key: 2,
            href: _ctx.item.iconFile,
            x: _ctx.x - _ctx.hotspotDiameter / 2 - 2.5,
            y: _ctx.y - _ctx.hotspotDiameter / 2 - 2.5,
            width: _ctx.hotspotDiameter + 5,
            height: _ctx.hotspotDiameter + 5,
            class: "ad-Point"
          }, null, 8, _hoisted_11))
        : _createCommentVNode("", true),
      (_ctx.completed)
        ? (_openBlock(), _createElementBlock("image", {
            key: 3,
            href: _ctx.completedIcon,
            x: _ctx.getDimentions('x', 'complete', _ctx.x),
            y: _ctx.getDimentions('y', 'complete', _ctx.y),
            width: _ctx.getDimentions('width', 'complete', 0),
            height: _ctx.getDimentions('height', 'complete', 0),
            class: "ad-Tick"
          }, null, 8, _hoisted_12))
        : _createCommentVNode("", true)
    ], 32),
    (!_ctx.edit && !_ctx.customHotspots)
      ? (_openBlock(), _createElementBlock("g", {
          key: 0,
          id: `point-dropdown-${_ctx.index}`,
          class: _normalizeClass(["ad-PointDropdown", {
      visible: _ctx.dropdownVisible,
      top: _ctx.labelOrientation === 'top',
      right: _ctx.labelOrientation === 'right',
      bottom: _ctx.labelOrientation === 'bottom',
      bottomStatic: _ctx.labelOrientation === 'bottom-static',
      topStatic: _ctx.labelOrientation === 'top-static',
      left: _ctx.labelOrientation === 'left',
    }]),
          style: _normalizeStyle(_ctx.dropdownStyle[`point-dropdown-${_ctx.index}`])
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("defs", null, [
            _createElementVNode("filter", {
              id: "drop_shadow",
              filterUnits: "objectBoundingBox",
              x: "-50%",
              y: "-60%",
              width: "250%",
              height: "250%"
            }, [
              _createElementVNode("feDropShadow", {
                in: "SourceGraphic",
                dx: "1",
                dy: "1",
                stdDeviation: "4",
                "flood-color": "darkgrey"
              })
            ])
          ], -1)),
          (_openBlock(), _createElementBlock("foreignObject", {
            x: _ctx.x - _ctx.dropdownWidth / 2,
            y: _ctx.y - _ctx.hotspotDiameter / 2,
            width: _ctx.dropdownWidth,
            "min-height": "1"
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", {
                innerHTML: _ctx.title,
                style: _normalizeStyle(_ctx.getDrowndownContainerStyle())
              }, null, 12, _hoisted_16),
              _createElementVNode("p", {
                class: "ad-PointDropdown-Progress",
                innerHTML: _ctx.progressCompleteText,
                style: _normalizeStyle(_ctx.getDrowndownContainerStyle())
              }, null, 12, _hoisted_17)
            ])
          ], 8, _hoisted_14))
        ], 14, _hoisted_13))
      : _createCommentVNode("", true)
  ], 64))
}